// extracted by mini-css-extract-plugin
export var category = "br10-na";
export var categoryBar = "br10-ra";
export var categoryBarLeft = "br10-ta";
export var categoryBarLeftDiscount = "br10-za";
export var categoryBarLeftDiscountHover = "br10-Aa";
export var categoryBarLeftDiscountHoverBtns = "br10-Ga";
export var categoryBarLeftDiscountHoverHover = "br10-Da";
export var categoryBarLeftDiscountHoverHoverBtns = "br10-Ha";
export var categoryBarLeftDiscountHoverHoverTop = "br10-Fa";
export var categoryBarLeftDiscountHoverLine = "br10-Ca";
export var categoryBarLeftDiscountHoverTop = "br10-Ea";
export var categoryBarLeftDiscountLine = "br10-Ba";
export var categoryBarLeftPrice = "br10-Ia";
export var categoryBarLeftPriceHove = "br10-Ja";
export var categoryBarLeftPriceHoveHover = "br10-Na";
export var categoryBarLeftPriceHoveHoverBtns = "br10-Ra";
export var categoryBarLeftPriceHoveHoverTop = "br10-Pa";
export var categoryBarLeftPriceHoveLine = "br10-La";
export var categoryBarLeftPriceHover = "br10-Ma";
export var categoryBarLeftPriceHoverBtns = "br10-Qa";
export var categoryBarLeftPriceHoverTop = "br10-Oa";
export var categoryBarLeftPriceLine = "br10-Ka";
export var categoryBarLeftSort = "br10-ua";
export var categoryBarLeftSortHover = "br10-xa";
export var categoryBarLeftSortHoverBg = "br10-wa";
export var categoryBarLeftSortHoverCurrent = "br10-ya";
export var categoryBarLeftSortText = "br10-va";
export var categoryBarRight = "br10-Sa";
export var categoryLoadMore = "br10-Ua";
export var categorySection = "br10-Ta";
export var categoryStep = "br10-oa";
export var categoryStepArrow = "br10-pa";
export var categoryTitle = "br10-qa";
export var searchBar = "br10-la";
export var searchBarBtn = "br10-ma";
export var searchBarKeyword = "br10-sa";
export var searchBarWrapper = "br10-ka";
export var searchInfoSection = "br10-Ya";
export var searchMoreKeywords = "br10-Va";
export var searchMoreKeywordsList = "br10-Xa";
export var searchMoreKeywordsTitle = "br10-Wa";
export var searchNav = "br10-ja";
export var searchRelatedArticles = "br10-Za";
export var searchRelatedArticlesTitle = "br10-_a";